import { ProfileBanner } from '@/app/components/ProfileBanner';
import { RedirectionPreAction } from '@/utils/urlHelper';
import dynamic from 'next/dynamic';
import React from 'react';
import { WithChildren } from 'types/withChildren';

import { Container } from '@material-ui/core';

import LandingHeader from 'modules/LandingHeader';

import css from './style.module.scss';

const CookieConsentPrompt = dynamic(() => import('@/app/components/CookieConsentPrompt'));

type LayoutType = WithChildren<{
  redirectUrl?: string;
  preAction?: RedirectionPreAction;
  onClickRegisterFn?: () => void;
}>;

export const Layout: React.FC<LayoutType> = ({
  redirectUrl,
  preAction,
  onClickRegisterFn,
  children,
}) => {
  return (
    <>
      <Container className={css.root}>
        <main className={css.main}>
          <LandingHeader
            redirectUrl={redirectUrl}
            preAction={preAction}
            onRegisterClick={onClickRegisterFn}
          />
          {children}
        </main>
      </Container>
      <CookieConsentPrompt />
      <ProfileBanner />
    </>
  );
};
